import React from 'react';
import { useNavigate } from 'react-router-dom';
import masaLogo from '../../Assets/MasaLogo.png';
import { resolveHomePath } from '../../utils/navigation';
import styles from './AppHeader.module.css';

const getDefaultLanguageLabel = (language) => (
  language === 'en' ? 'عربي' : 'English'
);

const AppHeader = ({
  title,
  subtitle,
  language,
  languageLabel,
  onToggleLanguage,
  logoSrc = masaLogo,
  logoAlt = 'Masa Logo',
  userType,
  showHome = false,
  homeLabel = 'Homepage',
  onHome,
  showLogout = false,
  logoutLabel = 'Logout',
  onLogout,
  actions,
  notificationSlot,
  children,
  className = '',
}) => {
  const navigate = useNavigate();

  const handleHome = () => {
    if (onHome) {
      onHome();
      return;
    }

    navigate(resolveHomePath(userType));
  };

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
      return;
    }

    localStorage.removeItem('authToken');
    navigate('/');
  };

  const headerClassName = [styles.appHeader, className].filter(Boolean).join(' ');

  return (
    <header className={headerClassName}>
      <div className={styles.brandCluster}>
        {logoSrc && (
          <img
            loading="lazy"
            src={logoSrc}
            alt={logoAlt}
            className={styles.logo}
          />
        )}
        <div className={styles.titleBlock}>
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
      </div>

      <div className={styles.actions}>
        {onToggleLanguage && (
          <button
            type="button"
            onClick={onToggleLanguage}
            className={`${styles.actionButton} ${styles.languageButton}`}
          >
            {languageLabel || getDefaultLanguageLabel(language)}
          </button>
        )}

        {showHome && (
          <button
            type="button"
            onClick={handleHome}
            className={`${styles.actionButton} ${styles.homeButton}`}
          >
            {homeLabel}
          </button>
        )}

        {showLogout && (
          <button
            type="button"
            onClick={handleLogout}
            className={`${styles.actionButton} ${styles.logoutButton}`}
          >
            {logoutLabel}
          </button>
        )}

        {actions}
        {children}

        {notificationSlot && (
          <div className={styles.notificationSlot}>
            {notificationSlot}
          </div>
        )}
      </div>
    </header>
  );
};

export default AppHeader;
